/* Unidentity: All / Women / Men toggle on the product gallery.
   Who is in each photo comes from its alt text: an explicit #model_w / #model_m tag first (placed before the
   #color_ tag), otherwise the words "woman"/"women" or "man"/"men". Photos with nobody in them show in every view.
   The theme already hides photos of other colours (filtered-indexes); this adds the model filter on top and
   re-applies it every time the theme changes the colour filter. The toggle only appears when a product has
   photos of both. On phones the dots become a "2/6" counter top right and the toggle sits at the bottom.
   It also keeps the size finder and the Drop Runway on the same choice (bottom of the file). */
(function () {
  if (window.__unModelGallery) return;
  window.__unModelGallery = true;

  var mobile = window.matchMedia('(max-width: 999px)');
  var LABELS = [['', 'All'], ['w', 'Women'], ['m', 'Men']];
  var items = function (g) { return Array.prototype.slice.call(g.querySelectorAll('.product-gallery__media')); };
  var pref = function () { return (window.unModel && window.unModel.get()) || ''; };

  function kind(media) {
    var img = media.querySelector('img');
    var a = ((img && img.getAttribute('alt')) || '').toLowerCase();
    if (a.indexOf('#model_w') > -1) return 'w';
    if (a.indexOf('#model_m') > -1) return 'm';
    if (/\bwom[ae]n\b/.test(a)) return 'w';
    if (/\b(man|men)\b/.test(a)) return 'm';
    return 'x';
  }

  function colourHidden(g) {
    try { return (g.filteredIndexes || []).slice(); } catch (e) { return []; }
  }

  function paint(g, v) {
    g.querySelectorAll('[data-un-model-set]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.getAttribute('data-un-model-set') === v));
    });
  }

  function fixSelection(g) {
    if (!mobile.matches) return; // desktop is a grid: nothing is "selected"
    var mc = g.querySelector('media-carousel');
    if (!mc || typeof mc.select !== 'function') return;
    var list = items(g);
    var i = mc.selectedIndex;
    if (list[i] && !list[i].hidden) return;
    var first = list.findIndex(function (m) { return !m.hidden; });
    if (first > -1) mc.select(first, { animate: false });
  }

  function apply(g) {
    var v = pref(), list = items(g), hide = colourHidden(g);
    if (v) {
      var extra = [];
      list.forEach(function (m, i) {
        var k = m.getAttribute('data-model');
        if (k !== 'x' && k !== v && hide.indexOf(i) < 0) extra.push(i);
      });
      // never leave a colour with no photos: if it has none of this model, show what it has
      if (extra.length && list.length - hide.length - extra.length > 0) hide = hide.concat(extra);
    }
    g.querySelectorAll('media-carousel, page-dots').forEach(function (c) {
      c.dispatchEvent(new CustomEvent('carousel:filter', { detail: { filteredIndexes: hide } }));
    });
    paint(g, v);
    fixSelection(g);
    count(g);
    setTimeout(function () { fixSelection(g); count(g); }, 80); // after the theme selects the new colour's first photo
  }

  /* ---------- phone: "2/6" counter top right instead of the dots ---------- */
  function count(g) {
    var c = g.__unCount, mc = g.querySelector('media-carousel');
    if (!c || !mc) return;
    var list = items(g).filter(function (m) { return !m.hidden; });
    var x = mc.getBoundingClientRect().left, cur = 0, best = Infinity;
    list.forEach(function (m, i) {
      var d = Math.abs(m.getBoundingClientRect().left - x);
      if (d < best) { best = d; cur = i; }
    });
    c.textContent = (cur + 1) + '/' + list.length;
    c.hidden = list.length < 2;
    // on phones the photos run edge to edge, past the page margins the counter's frame sits in:
    // measure from the photo's visible edges so the gap is 12px from the top and 12px from the right
    var host = c.parentNode, r = host.getBoundingClientRect(), p = mc.getBoundingClientRect();
    var cw = document.documentElement.clientWidth;
    var visL = Math.max(p.left, 0), visR = Math.min(p.right, cw);
    c.style.right = Math.round(12 + r.right - visR) + 'px';
    c.style.top = Math.round(12 + p.top - r.top) + 'px';
    var bar = host.querySelector('.un-model'); // and keep the toggle centred on the photo
    if (bar) {
      bar.style.left = mobile.matches ? Math.round(visL - r.left) + 'px' : '';
      bar.style.right = mobile.matches ? Math.round(r.right - visR) + 'px' : '';
    }
  }

  function counter(g) {
    var host = g.querySelector('.product-gallery__media-list-wrapper'), mc = g.querySelector('media-carousel');
    if (!host || !mc || g.__unCount) return;
    var c = document.createElement('div');
    c.className = 'un-count';
    c.setAttribute('aria-hidden', 'true'); // the theme's carousel already announces position to screen readers
    host.appendChild(c);
    g.__unCount = c;
    g.setAttribute('data-un-count', '');
    var queued = false;
    mc.addEventListener('scroll', function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; count(g); });
    }, { passive: true });
    ['carousel:select', 'carousel:settle', 'carousel:change'].forEach(function (t) { mc.addEventListener(t, function () { setTimeout(function () { count(g); }, 0); }); });
    window.addEventListener('resize', function () { count(g); });
    count(g);
  }

  function bar() {
    var wrap = document.createElement('div');
    wrap.className = 'un-model';
    var seg = document.createElement('div');
    seg.className = 'un-model__seg';
    seg.setAttribute('role', 'group');
    seg.setAttribute('aria-label', 'Show photos on');
    LABELS.forEach(function (l) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('data-un-model-set', l[0]);
      b.setAttribute('aria-pressed', 'false');
      b.textContent = l[1];
      seg.appendChild(b);
    });
    wrap.appendChild(seg);
    return wrap;
  }

  function init(g) {
    if (g.__unModel) return;
    g.__unModel = true;
    var list = items(g), w = 0, m = 0;
    list.forEach(function (it) {
      var k = kind(it);
      it.setAttribute('data-model', k);
      if (k === 'w') w++; else if (k === 'm') m++;
    });
    counter(g); // every gallery gets the counter, toggle or not
    // the theme rewrites filtered-indexes on every colour change, then re-filters: run after it
    new MutationObserver(function () { if (g.hasAttribute('data-un-model')) apply(g); else count(g); })
      .observe(g, { attributes: true, attributeFilter: ['filtered-indexes'] });
    if (!w || !m) return; // one model only (or none): nothing to choose
    var host = g.querySelector('.product-gallery__media-list-wrapper');
    if (!host) return;
    host.insertBefore(bar(), host.firstChild);
    g.setAttribute('data-un-model', '');

    g.addEventListener('click', function (e) {
      var b = e.target.closest('[data-un-model-set]');
      if (!b || !window.unModel) return;
      e.preventDefault();
      e.stopPropagation(); // not a tap on the photo (zoom)
      window.unModel.set(b.getAttribute('data-un-model-set'), 'pdp');
    });
    apply(g);
  }

  function scan() { document.querySelectorAll('product-gallery').forEach(init); }

  document.addEventListener('un:model', function () {
    document.querySelectorAll('product-gallery[data-un-model]').forEach(apply);
  });

  /* ---------- the same choice in the size finder and the Drop Runway ---------- */
  // Women / Men picked in either one becomes the site-wide choice
  document.addEventListener('click', function (e) {
    if (!window.unModel) return;
    var sex = e.target.closest('.usf-sheet [data-act="sex"]');
    if (sex) { window.unModel.set(sex.getAttribute('data-v'), 'size_finder'); return; }
    var seg = e.target.closest('drop-runway .dr__seg-btn');
    if (seg && !seg.disabled) window.unModel.set(seg.getAttribute('data-g'), 'drop_runway');
  }, true);

  // a first-time size finder opens on Women when that is the choice (it defaults to Men otherwise)
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.usf-trigger') || pref() !== 'w') return;
    try { if (localStorage.getItem('un_fit_profile_v1')) return; } catch (err) { return; }
    requestAnimationFrame(function () {
      var b = document.querySelector('.usf-sheet [data-act="sex"][data-v="w"]');
      if (b && b.getAttribute('aria-pressed') !== 'true') b.click();
    });
  });

  // the Drop Runway starts each look on the chosen model: set it in the look data before the runway reads it
  // (this file loads in <head>, the runway script after it)
  (function () {
    var v = pref();
    if (!v) return;
    document.querySelectorAll('drop-runway [data-dr-data]').forEach(function (s) {
      try {
        var d = JSON.parse(s.textContent);
        if (d && d.g !== v) { d.g = v; s.textContent = JSON.stringify(d); }
      } catch (err) {}
    });
  })();

  // wait for the theme's gallery and carousel to be live, so the colour filter is readable and filters are heard
  function ready() {
    if (!window.customElements) return;
    Promise.all(['product-gallery', 'media-carousel'].map(function (t) { return customElements.whenDefined(t); })).then(scan);
  }
  document.addEventListener('shopify:section:load', ready);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready); else ready();
})();
